import React from 'react'
import { createRoot } from 'react-dom/client'
import Providers from 'containers/Providers'
import isSquadUrlLocationUtil from 'utils/location/is-squad-url'
import SquadPage from 'pages/Squad/containers'

export default function initSquadPageUtil () {
  logUtil('initSquadPageUtil').debug('[start]')

  if (!isSquadUrlLocationUtil()) {
    logUtil('initSquadPageUtil').debug('[noop] not squad page')
    return
  }

  const main = document.querySelector('main')
  if (!main) {
    logUtil('initSquadPageUtil').debug('[noop] no main')
    return
  }

  const domNode = document.createElement('div')
  domNode.id = 'SquadPage'
  main.appendChild(domNode)

  const root = createRoot(domNode)
  root.render(
    <Providers>
      <SquadPage />
    </Providers>
  )
}
